/**
 * @returns A simple title card.
 */
const TitleCard = () => {
  return (
    <div id="title">
      <h1>Sorting Algorithms</h1>
      <h4>
        <i>WARNING: Animation contains flashing lights</i>
      </h4>
      
    </div>
  );
};

export default TitleCard;
